<template>
  <div>
    <StockPurchaseOrderListByStatus :statusId="statusId" :pageTitle="pageTitle">
    </StockPurchaseOrderListByStatus>
  </div>
</template>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";

import StockPurchaseOrderListByStatus from "@/modules/stock/components/purchase-orders/StockPurchaseOrderListByStatus.vue";

import _ from "lodash";
export default {
  name: "StockPurchaseOrderListProcessing",
  mixins: [permissionMixin],
  data() {
    return {
      statusId: 2,
      pageTitle: this.$t("LIST_PROCESSING_STOCK_PURCHASE_ORDERS")
    };
  },
  components: { StockPurchaseOrderListByStatus },
  watch: {},
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Processing Stock Purchase Orders List" }
    ]);
  },
  computed: {},
  methods: {}
};
</script>
